"use client";

import { useSession } from "next-auth/react";
import { CircularProgress } from "@nextui-org/progress";
import Login from "./Login";
import Logout from "./Logout";

export const LoginSection = () => {
  const { status, data } = useSession();
  if (status === "loading") {
    return (
      <CircularProgress size="sm" aria-label="Loading..." color="primary" />
    );
  } else {
    if (status === "authenticated") {
      return <Logout data={data} />;
    }
    return <Login />;
  }
};
